import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "@/components/shared/data-table/data-table-column-header";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    cell: ({ row }) => <div>{row.getValue("id")}</div>,
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => <div>{row.getValue("name")}</div>,
  },
  // {
  //   accessorKey: "createdAt",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Created At" />
  //   ),
  //   cell: ({ row }) => (
  //     <div>{new Date(row.getValue("createdAt")).toLocaleDateString()}</div>
  //   ),
  // },
  // {
  //   accessorKey: "updatedAt",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Updated At" />
  //   ),
  //   cell: ({ row }) => (
  //     <div>{new Date(row.getValue("updatedAt")).toLocaleDateString()}</div>
  //   ),
  // },
  {
    id: "actions",
    cell: ({ row }) => {
      const navigate = useNavigate();
      return (
        <Button
          variant="outline"
          size="sm"
          onClick={() =>
            navigate(
              `/dashboard/b2b-accounts/price-lists/${row.getValue("id")}`
            )
          }
        >
          View Details
        </Button>
      );
    },
  },
];
